import httpClient from 'api/httpClient';
import { SaleOrder } from 'models/SaleOrder';
import {
  Pagination,
  RequestParams,
} from 'router/subrouters/Dashboard/pages/hooks/usePaginatedItems';

const getSaleOrders = (params: RequestParams<any>) =>
  httpClient
    .get<Pagination<SaleOrder>>('/sales-order-admin', { params })
    .then(({ data }) => data);

const getExpiredOders = (params: RequestParams<any>) =>
  httpClient
    .get<Pagination<SaleOrder>>(`/sales-order-admin?expired=true`, {
      params,
    })
    .then(({ data }) => data);

const getOrderById = (id: string) =>
  httpClient.get<SaleOrder>(`/sales-order-admin/${id}`);

export default { getSaleOrders, getExpiredOders, getOrderById };
